import { UntypedFormGroup } from '@angular/forms';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DatepickerComponent } from "../../../../shared/components/form/index";
import { Log } from "ng2-logger";
import { ToolService } from "../../../../core/services/tool.service";
import { ToolStorage } from "../../../model/toolLocation.model";
import * as _ from 'lodash';

@Component({
    selector: 'app-tool-location-form',
    templateUrl: 'tool-location-form.component.html',
    styleUrls: ['tool-location-form.component.scss']
})
export class ToolLocationFormComponent implements OnInit, OnChanges {
    _logger = Log.create(ToolLocationFormComponent.name);
    @ViewChild(DatepickerComponent, {static: true}) datePicker: DatepickerComponent;
    @Input() toolStorages: ToolStorage[];
    @Input() toolName = '';
    @Input() showValidations = false;

    form: UntypedFormGroup;

    constructor(private toolService: ToolService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['toolStorages']) {
            this.initForm();
        }
    }

    ngOnInit() {
        this.initForm();
    }

    submit() {
        this._logger.info('submit::')
    }

    initForm() {
        this.form = this.toolService.buildLocationFormGroup(this.toolStorages);
    }

    resetForm() {
        this._logger.info("resetForm:: with", this.toolStorages);
        this.showValidations = false;
        this.form.reset();
    }

    onLocationChange(event) {
        /**TODO this would be wayyyy coooler with two way binding instead of this sort of updating **/
        this._logger.info("onLocationChange:: Changed location to", event);
        const arrayId = _.findIndex(this.toolStorages, {key: event.key});
        this.toolStorages.splice(arrayId, event);
    }

    getFormValue(): ToolLocationFormComponent {
        return this.form.value;
    }

    get isFormValid() {
        let valid = true;

        if (this.form && this.form.value) {
            this.toolStorages.forEach((location) => {
                if (this.form.controls && this.form.controls[location.key]) {
                    const locationForm = this.form.controls[location.key];
                    valid = valid && locationForm.valid;
                }
            });
        }
        return valid;
    }
}
